<template>
  <ol class="tag-button-list">
    <li v-for="(tag, index) in data">
      <AppTagButton :key="`tag_${index}`" :data="tag"/>
    </li>
  </ol>
</template>

<script setup lang="ts">
import {TTag} from '~/types/other-types'

const props = defineProps<{
  data: TTag[],
}>()
</script>

<style scoped lang="postcss">
.tag-button-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

/*  */
</style>
